import {clsx} from 'clsx';

type Props = {
  variant: 'orange' | 'white';
  label: string;
};

export default function ProductBadge({variant, label}: Props) {
  return (
    <span
      className={clsx(
        'rounded-full border px-3 py-1 text-sm font-bold',
        variant === 'white' && 'border-white text-white',
        variant === 'orange' && 'border-orange text-orange',
      )}
    >
      {label}
    </span>
  );
}
